import { environmentVariables, ExternalEnvironmentVariables } from '../lib/environment-variables'

import { useAppSettings } from './use-app-settings'

export const useEnvironmentVariable = (key: keyof ExternalEnvironmentVariables) => {
  const appSettings = useAppSettings()
  return environmentVariables[`REACT_APP_${key}`] || appSettings.env[key]
}
